export default "__VITE_ASSET__C0qo7MOB__"